import { FontItem } from "layout/common/controls-area/cover-text-input/cover-text-input-item";
import { LayoutFont } from "ui/constants";

enum Baseline {
    hanging = "hanging",
    middle = "middle",
    baseline = "baseline",
}

enum Anchor {
    start = "start",
    middle = "middle",
    end = "end",
}

enum TextAlignment {
    Left = "left",
    Center = "center",
    Right = "right",
}

enum DayModuleType {
    Food = "Food",
    Mood = "Mood",
    Sleep = "Sleep",
    Time = "Time",
    Water = "Water",
    Weather = "Weather",
    Training = "Training",
}

enum WeekModuleType {
    Training = "Training",
    Mood = "Mood",
    Dotted = "Dotted",
    Lines = "Lines",
    Month = "Month",
    Notes = "Notes",
    Phone = "Phone",
    School = "School",
    Shoppinglist = "Shoppinglist",
    Squares = "Squares",
    Study = "Study",
    Blank = "Blank",
    Dinner = "Dinner",
    Budget = "Budget",
    Goals = "Goals",
    Habits = "Habits",
    Isometric = "Isometric",
    Meetings = "Meetings",
    Sleeptracker = "Sleeptracker",
    Dinner_en = "Dinner_en",
    Goals_en = "Goals_en",
    Habits_en = "Habits_en",
    Meetings_en = "Meetings_en",
    School_en = "School_en",
    Sleeptracker_en = "Sleeptracker_en",
    Study_en = "Study_en",
    Mood_en = "Mood_en",
    Dinner_de = "Dinner_de",
    Goals_de = "Goals_de",
    Habits_de = "Habits_de",
    Meetings_de = "Meetings_de",
    School_de = "School_de",
    Sleeptracker_de = "Sleeptracker_de",
    Study_de = "Study_de",
    Mood_de = "Mood_de",
}

enum CalendarType {
    Calendar = "calendar",
    Notebook = "notebook",
}

enum CalendarLayoutType {
    Standing = "Standing",
    Laying = "Laying",
    LayingLeft = "Layingleft",
}

enum Page {
    Odd = "Odd",
    Even = "Even",
}

enum PageSelector {
    Left = ".leftPageSvg",
    Right = ".rightPageSvg",
}

type IconPickerItem = {
    resourceKey?: string | null;
    icon?: string | null;
    image?: string | null;
    value: string;
};

const DayModuleItems: Array<IconPickerItem> = [
    { resourceKey: "DayModules_Weather", icon: "fa-sun", value: "Weather" },
    { resourceKey: "DayModules_Water", icon: "fa-tint", value: "Water" },
    {
        resourceKey: "DayModules_Workout",
        icon: "fa-dumbbell",
        value: "Training",
    },
    { resourceKey: "DayModules_Dinner", icon: "fa-utensils", value: "Food" },
    { resourceKey: "DayModules_Mood", icon: "fa-smile", value: "Mood" },
    { resourceKey: "DayModules_Time", icon: "fa-clock", value: "Time" },
    { resourceKey: "DayModules_Sleep", icon: "fa-bed", value: "Sleep" },
    { resourceKey: "DayModules_Blank", icon: "fa-blank", value: "Blank" },
];

const WeekModuleItems: Array<IconPickerItem> = [
    {
        resourceKey: "WeekModules_WorkOut",
        icon: "fa-dumbbell",
        value: "Training",
    },
    { resourceKey: "WeekModules_Mood", icon: "fa-smile", value: "Mood" },
    { resourceKey: "WeekModules_Dots", icon: "fa-dot-circle", value: "Dotted" },
    { resourceKey: "WeekModules_Lines", icon: "fa-bars", value: "Lines" },
    {
        resourceKey: "WeekModules_Month",
        icon: "fa-calendar-alt",
        value: "Month",
    },
    { resourceKey: "WeekModules_Notes", icon: "fa-list", value: "Notes" },
    { resourceKey: "WeekModules_Phone", icon: "fa-phone", value: "Phone" },
    { resourceKey: "WeekModules_School", icon: "fa-school", value: "School" },
    {
        resourceKey: "WeekModules_Shopping",
        icon: "fa-shopping-cart",
        value: "Shoppinglist",
    },
    { resourceKey: "WeekModules_Squares", icon: "fa-square", value: "Squares" },
    {
        resourceKey: "WeekModules_Study",
        icon: "fa-graduation-cap",
        value: "Study",
    },
    {
        resourceKey: "WeekModules_Budget",
        icon: "fa-money-bill",
        value: "Budget",
    },
    { resourceKey: "WeekModules_Dinner", icon: "fa-utensils", value: "Dinner" },
    { resourceKey: "WeekModules_Goals", icon: "fa-medal", value: "Goals" },
    { resourceKey: "WeekModules_Habits", icon: "fa-walking", value: "Habits" },
    {
        resourceKey: "WeekModules_Isometric",
        icon: "fa-asterisk",
        value: "Isometric",
    },
    {
        resourceKey: "WeekModules_Meetings",
        icon: "fa-calendar-alt",
        value: "Meetings",
    },
    {
        resourceKey: "WeekModules_Sleeptracker",
        icon: "fa-bed",
        value: "Sleeptracker",
    },
    { resourceKey: "WeekModules_Blank", icon: "fa-blank", value: "Blank" },
];

const ValidFontSizes: Array<FontItem> = [
    { Name: "8", Value: "24" },
    { Name: "12", Value: "36" },
    { Name: "16", Value: "48" },
    { Name: "20", Value: "60" },
    { Name: "26", Value: "78" },
    { Name: "32", Value: "96" },
    { Name: "40", Value: "120" },
    { Name: "48", Value: "144" },
    { Name: "60", Value: "180" },
    { Name: "72", Value: "216" },
    { Name: "84", Value: "252" },
    { Name: "100", Value: "300" },
    { Name: "120", Value: "360" },
    { Name: "140", Value: "420" },
    { Name: "160", Value: "480" },
    { Name: "180", Value: "540" },
    { Name: "200", Value: "600" },
    { Name: "250", Value: "750" },
    { Name: "330", Value: "990" },
    { Name: "400", Value: "1200" },
    { Name: "550", Value: "1650" },
];

const NotebookMinNumberOfExtraPages: number = 2;
const NotebookDefaultMaxNumberOfExtraPages: number = 144;
const NotebookMaxNumberOfExtraPagesForB5: number = 196;
const A5CalendarNumberOfExtraPages: number = 36; // Also used for A6
const B5CalendarNumberOfExtraPages: number = 88;
const MonthDividerNumberOfPages: number = 24;
const ExtraPagePageSize: number = 2;
const DynamicWeekModuleId: number = 1252;
// See VOCABULARY.md for explanation of the below values
const SvgId = "calendarSVG";

const BleedSize = 30;

type CalendarSizeDimensions = {
    calendarSize: string;
    contentWidthWithoutBleeds: number;
    contentHeightWithoutBleeds: number;
    yearOverviewIdHeight: number;
    presentationEmptySpaceWidth: number;
    presentationEmptySpaceHeight: number;
    spiralWidth: number;
    spiralHeight: number;
    spiralTranslateX: number;
    spiralTranslateY: number;
    numberOfSpirals: number;
    // contentWidthWithoutBleeds + bleedSize * 2
    svgWidth: number;
    // contentHeightWithoutBleeds + bleedSize * 2
    svgHeight: number;
    spiralMargin: number;
    // spiralMargin / 3
    spiralHoleWidth: number;
    headerHeight: number;
    modulesInnerMargin: number;
    moduleContainerHeight: number;
    pageGap: number;
    snoddWidth: number;
    snoddImageHeight: number;
    snoddStartPosY: number;
    snoddStartPosX: number;
    snoddTotalHeight: number; // NOTE(Jesper): Allow to conditionally set a total height for the rubberband, as a means to override the dynamic height
    optionalDayStartPosX: number;
    optionalDayIconWidth: number;
    optionalDayIconHeight: number;
    adjustmentFactor: number;
    initialCoverTextX: number;
    initialCoverTextY: number;
    initialCoverTextFontSize: string;
};

const CalendarResizeDimensions = {
    a5ContentWidthWithoutBleeds: 1485,
    a5ContentHeightWithoutBleeds: 2100,
    a6ContentWidthWithoutBleeds: 1050,
    a6ContentHeightWithoutBleeds: 1485,
    b5ContentWidthWithoutBleeds: 1820,
    b5ContentHeightWithoutBleeds: 2570,
    ownerPageDimension: 800,
};

const CalendarDimensions: Array<CalendarSizeDimensions> = [
    {
        calendarSize: "A5",
        contentWidthWithoutBleeds:
            CalendarResizeDimensions.a5ContentWidthWithoutBleeds,
        contentHeightWithoutBleeds:
            CalendarResizeDimensions.a5ContentHeightWithoutBleeds,
        yearOverviewIdHeight: 2076,
        presentationEmptySpaceWidth: 300,
        presentationEmptySpaceHeight: 150,
        spiralWidth: 220,
        spiralHeight: 50,
        spiralTranslateX: -110,
        spiralTranslateY: -25,
        numberOfSpirals: 24,
        svgWidth: 1545,
        svgHeight: 2160,
        spiralMargin: 90,
        spiralHoleWidth: 30,
        headerHeight: 200,
        modulesInnerMargin: 20,
        moduleContainerHeight: 650,
        pageGap: 60,
        snoddWidth: 20,
        snoddTotalHeight:
            CalendarResizeDimensions.a5ContentHeightWithoutBleeds + 50,
        snoddImageHeight: 108,
        snoddStartPosY: 125,
        snoddStartPosX: 1665,
        optionalDayStartPosX: 340,
        optionalDayIconWidth: 50,
        optionalDayIconHeight: 45,
        adjustmentFactor: 1,
        initialCoverTextY: 1600,
        initialCoverTextX: 750,
        initialCoverTextFontSize: "144",
    },
    {
        calendarSize: "A6",
        contentWidthWithoutBleeds:
            CalendarResizeDimensions.a6ContentWidthWithoutBleeds,
        contentHeightWithoutBleeds:
            CalendarResizeDimensions.a6ContentHeightWithoutBleeds,
        yearOverviewIdHeight: 1485,
        presentationEmptySpaceWidth: 212,
        presentationEmptySpaceHeight: 106,
        spiralWidth: 218,
        spiralHeight: 49,
        spiralTranslateX: -118,
        spiralTranslateY: -17.5,
        numberOfSpirals: 17,
        svgWidth: 1110,
        svgHeight: 1545,
        spiralMargin: 64,
        spiralHoleWidth: 21,
        headerHeight: 141,
        modulesInnerMargin: 14,
        moduleContainerHeight: 460,
        pageGap: 42,
        snoddWidth: 14,
        snoddTotalHeight:
            CalendarResizeDimensions.a6ContentHeightWithoutBleeds + 50,
        snoddImageHeight: 76,
        snoddStartPosY: 82,
        snoddStartPosX: 1177,
        optionalDayStartPosX: 238,
        optionalDayIconWidth: 35,
        optionalDayIconHeight: 30,
        adjustmentFactor: 0.707,
        initialCoverTextY: 1014,
        initialCoverTextX: 530,
        initialCoverTextFontSize: "96",
    },
    {
        calendarSize: "B5",
        contentWidthWithoutBleeds:
            CalendarResizeDimensions.b5ContentWidthWithoutBleeds,
        contentHeightWithoutBleeds:
            CalendarResizeDimensions.b5ContentHeightWithoutBleeds,
        yearOverviewIdHeight: 2076,
        presentationEmptySpaceWidth: 300,
        presentationEmptySpaceHeight: 150,
        spiralWidth: 273,
        spiralHeight: 73,
        spiralTranslateX: -168,
        spiralTranslateY: -25,
        numberOfSpirals: 19,
        svgWidth:
            CalendarResizeDimensions.b5ContentWidthWithoutBleeds +
            BleedSize * 2,
        svgHeight:
            CalendarResizeDimensions.b5ContentHeightWithoutBleeds +
            BleedSize * 2,
        spiralMargin: 90,
        spiralHoleWidth: 30,
        headerHeight: 200,
        modulesInnerMargin: 20,
        moduleContainerHeight: 650,
        pageGap: 60,
        snoddWidth: 20,
        snoddImageHeight: 108,
        snoddTotalHeight: 2600,
        snoddStartPosY: 135,
        snoddStartPosX: 1905,

        optionalDayStartPosX: 340,
        optionalDayIconWidth: 50,
        optionalDayIconHeight: 45,
        adjustmentFactor: 1,
        initialCoverTextY: 2400,
        initialCoverTextX: 910,
        initialCoverTextFontSize: "180",
    },
];

const CoverImageDrawWidth = 644;
const CoverImageDrawHeight = 900;

enum CalendarSizes {
    A5 = "a5",
    A6 = "a6",
    B5 = "b5",
    Preview = "preview",
    Default = A5,
}

// Legacy fonts. Can be removed when there are no more legacy fonts in the system.
const LegacyFonts: Array<LayoutFont> = [
    {
        title: "Classic",
        thumbnail: "",
        url: "fonts/benton-modern-display.woff",
        "font-family": "benton-modern-display",
        format: "woff",
    },
    {
        title: "Modern",
        thumbnail: "",
        url: "fonts/filson-pro.woff",
        "font-family": "filson-pro",
        format: "woff",
    },
    {
        title: "Scribble",
        thumbnail: "",
        url: "fonts/molyna-regular-webfont.woff",
        "font-family": "molyna-regular-webfont",
        format: "woff",
    },
    {
        title: "Swag",
        thumbnail: "",
        url: "fonts/Futura-Medium.otf",
        "font-family": "futura-Medium",
        format: "otf",
    },
    {
        title: "Clover",
        thumbnail: "",
        url: "fonts/clover-regular.woff",
        "font-family": "clover",
        format: "woff",
    },
];

export {
    Page,
    TextAlignment,
    SvgId,
    Anchor,
    Baseline,
    CoverImageDrawWidth,
    CoverImageDrawHeight,
    BleedSize,
    CalendarResizeDimensions,
    CalendarSizeDimensions,
    CalendarDimensions,
    PageSelector,
    CalendarType,
    DayModuleType,
    ValidFontSizes,
    WeekModuleType,
    DayModuleItems,
    WeekModuleItems,
    CalendarLayoutType,
    NotebookMinNumberOfExtraPages,
    NotebookDefaultMaxNumberOfExtraPages,
    NotebookMaxNumberOfExtraPagesForB5,
    A5CalendarNumberOfExtraPages,
    B5CalendarNumberOfExtraPages,
    MonthDividerNumberOfPages,
    ExtraPagePageSize,
    DynamicWeekModuleId,
    CalendarSizes,
    IconPickerItem,
    LegacyFonts,
};
